"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function removeJWPlayerInstance(playerId, context) {
  var player = context.jwplayer && context.jwplayer(playerId);

  if (player) {
    player.remove();
  }
}

exports.default = removeJWPlayerInstance;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jw-player/dist/helpers/remove-jw-player-instance.js
// module id = 880
// module chunks = 10 11